import clsx from 'clsx';
import styles from '../../RelatedParties.module.scss';
import { getImage, relationEdgeFallbackLabels, relationTypeMap } from '../../relatedParty_constants';
import { toTitleCase } from '../../../../../../utils/utils';
import { alertIcon, alertIconDisabled } from '../../../../../../assets/hostedassets';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';

function SecondDegreeRow({ isPDFReport, entityEntry, row, handleAlertsClick, isProbeEnabled }) {
    const getRelationType = (parentType: string, childType: string, edgeType: string) => {
        return relationTypeMap[parentType]?.[childType]?.[edgeType] || relationEdgeFallbackLabels[edgeType] || '';
    };

    return (
        <tr className={clsx(styles.FirstDegreeRow, styles.SecondDegreeRow)} key={row?.fromKid}>
            <td className={styles.RowItem}></td>

            {/* Details column: degree-1 owns it, degree-2 rows show nothing (unchanged) — kept
                here only so this row's cells still line up with the header's 6 columns. */}
            <td className={styles.RowItem}></td>

            <td className={styles.RowItem}>{getRelationType(entityEntry?.type, row?.type, row?.edgeType) || ''}</td>

            <td className={styles.RowItem}>
                <div className={styles.EntityNameContainer}>
                    <div className={styles.EntityNamePill}>
                        {!isPDFReport && (
                            <img
                                src={getImage(row?.type)}
                                alt="ent"
                                height={'14px'}
                                style={{
                                    marginTop: '2px',
                                }}
                            />
                        )}
                        <Tooltip
                            content={`${toTitleCase(row?.fromName) || '-'}${row?.designation ? ` (${row.designation})` : ''}`}
                            direction="top"
                            contentCss={{ whiteSpace: 'nowrap' }}
                            fitContent
                            small
                            usePortal
                        >
                            <span className={styles.Text}>
                                <span className={styles.PersonName}>{toTitleCase(row?.fromName) || '-'}</span>
                                {row?.designation && <span className={styles.DesignationText}> ({row.designation})</span>}
                            </span>
                        </Tooltip>
                    </div>
                </div>
            </td>

            <td className={styles.RowItem}>
                <div
                    className={clsx(styles.Risk, {
                        [styles.Risk_Severe]: row?.risk === 'SEVERE',
                        [styles.Risk_High]: row?.risk === 'HIGH',
                        [styles.Risk_Medium]: row?.risk === 'MEDIUM',
                        [styles.Risk_Low]: row?.risk === 'LOW',
                    })}
                >
                    {row?.risk && row?.risk !== 'null' ? toTitleCase(row?.risk) : 'NA'}
                </div>
            </td>

            {!isPDFReport && (
                <td className={styles.RowItem}>
                    {isProbeEnabled && !row?.alerts?.length ? (
                        <Tooltip
                            content="AICA can't fetch alerts for this"
                            direction="top"
                            contentCss={{ color: 'black', whiteSpace: 'nowrap' }}
                            fitContent
                            small
                            usePortal
                        >
                            <div className={clsx(styles.Alerts, styles.Alerts_Disabled)}>
                                <img
                                    src={alertIconDisabled}
                                    alt="alert"
                                    style={{
                                        margin: '0px 5px 2px 0',
                                    }}
                                />
                                <span>NA</span>
                            </div>
                        </Tooltip>
                    ) : (
                        <div
                            className={clsx(styles.Alerts, {
                                [styles.Alerts_Disabled]: !row?.alerts?.length,
                            })}
                            onClick={() => {
                                handleAlertsClick(row);
                            }}
                        >
                            <img
                                src={row?.alerts?.length ? alertIcon : alertIconDisabled}
                                alt="alert"
                                style={{
                                    margin: '0px 5px 2px 0',
                                }}
                            />
                            <span>{row?.alerts?.length} Alerts</span>
                        </div>
                    )}
                </td>
            )}
        </tr>
    );
}

export default SecondDegreeRow;
